module.exports = __webpack_public_path__ + "static/media/state2022.e393ec9e.jpeg";